import './App.css';
import Navbar from './components/Navbar';
import AboutPage from './pages/AboutPage';
import AppsPage from './pages/AppsPage';
import HomePage from './pages/HomePage';
import BlockBlitzPolicyPage from './pages/privacyPolicy/policy';
import PockliPolicyPage from './pages/privacyPolicy/pockliPolicy';

function getPageFromPath(pathname) {
  if (pathname === '/about') {
    return 'about';
  }
  if (pathname === '/apps') {
    return 'apps';
  }
  if (
    pathname === '/privacy-policy/block-blitz' ||
    pathname === '/privacy-policy/block-blitz/'
  ) {
    return 'block-blitz-policy';
  }
  if (pathname === '/privacy-policy/pockli' || pathname === '/privacy-policy/pockli/') {
    return 'pockli-policy';
  }
  return 'home';
}

function renderPage(pageKey) {
  if (pageKey === 'about') {
    return <AboutPage />;
  }
  if (pageKey === 'apps') {
    return <AppsPage />;
  }
  if (pageKey === 'block-blitz-policy') {
    return <BlockBlitzPolicyPage />;
  }
  if (pageKey === 'pockli-policy') {
    return <PockliPolicyPage />;
  }
  return <HomePage />;
}

function App() {
  const currentKey = getPageFromPath(window.location.pathname);
  const mainClassName =
    currentKey === 'apps' || currentKey === 'block-blitz-policy' || currentKey === 'pockli-policy'
      ? 'hero apps-hero'
      : 'hero';

  return (
    <div className="site-shell">
      <Navbar activePage={currentKey} />

      <main className={mainClassName}>{renderPage(currentKey)}</main>
    </div>
  );
}

export default App;
